<template>
  <CHeader>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CBreadcrumbRouter class="border-0 my-auto"/>
    <CHeaderNav class="ml-auto">
      <!--
      <TheHeaderDropdownNotif/>
      <TheHeaderDropdownTasks/>
      <TheHeaderDropdownMssgs/>
      <TheHeaderDropdownAccnt/>
      -->
    </CHeaderNav>
  </CHeader>
</template>

<script>
//import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
import TheHeaderDropdownNotif from './TheHeaderDropdownNotif'
//import TheHeaderDropdownTasks from './TheHeaderDropdownTasks'
//import TheHeaderDropdownMssgs from './TheHeaderDropdownMssgs'

export default {
  name: 'TheHeader',
  components: {
    //TheHeaderDropdownAccnt,
    TheHeaderDropdownNotif,
    //TheHeaderDropdownTasks,
    // TheHeaderDropdownMssgs
  }
}
</script>
